import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import { soket_url, image_baseurl } from "../Utils/config";
import { basicsettinglist } from "../App/Services/Admin/Admin";

const SOCKET_SERVER_URL = soket_url;
const socket = io(SOCKET_SERVER_URL, { transports: ["websocket"] });

const NotificationListener = () => {
    const [favicon, setFavicon] = useState("");
    const notificationChannelRef = useRef(null);
    const lastNotificationRef = useRef({});

    useEffect(() => {
        getFavicon();
    }, []);

    const getFavicon = async () => {
        try {
            const response = await basicsettinglist();
            if (response?.status && response?.data?.[0]?.favicon) {
                setFavicon(response.data[0].favicon);
            }
        } catch (error) {
            console.error("Error fetching favicon:", error);
        }
    };

    useEffect(() => {
        if ("Notification" in window && Notification.permission !== "granted") {
            Notification.requestPermission();
        }

        const notificationChannel = new BroadcastChannel("notification_channel");
        notificationChannelRef.current = notificationChannel;

        const showIfNotDuplicate = (data, fromSocket = false) => {


            if (!data) return;
            const localId = localStorage.getItem("id");
            const localRole = localStorage.getItem("Role");
            if (!localId || !localRole) return;

            const key = `${data.title}-${data.message}-${data.timestamp || ""}`;
            if (lastNotificationRef.current[key]) return;
            lastNotificationRef.current[key] = true;


            if (localRole === "ADMIN" && data.for === "ADMIN") {
                showToast(data);
                showBrowserNotification(data, favicon);
            } else if (localRole === "USER") {
                const isMatched =
                    Array.isArray(data.clientIds)
                        ? data.clientIds.map(String).includes(String(localId))
                        : String(data.clientIds) === String(localId);

                if (isMatched) {
                    showToast(data);
                    showBrowserNotification(data, favicon);
                }
            }

            if (fromSocket) {
                notificationChannel.postMessage(data);
            }
        };


        socket.off("adminnotification");
        socket.off("clientnotification");

        socket.on("adminnotification", (data) => {
            data.for = "ADMIN";
            showIfNotDuplicate(data, true);
        });

        socket.on("clientnotification", (data) => {
            data.for = "USER";
            showIfNotDuplicate(data, true);
        });

        notificationChannel.onmessage = (event) => {
            showIfNotDuplicate(event.data, false);
        };

        return () => {
            socket.off("adminnotification");
            socket.off("clientnotification");
            notificationChannel.close();
        };
    }, [favicon]);

    return null;
};

export default NotificationListener;

const showToast = (data) => {
    toast.info(
        <div style={{ lineHeight: "1.4", fontSize: "14px" }}>
            <strong>📢 {data.title || "New Notification"}</strong>
            <div>
                <b>📝 Message:</b> {data.message}
            </div>
            {data.type && (
                <div>
                    <b>🧾 Type:</b> {data.type}
                </div>
            )}
        </div>,
        {
            position: "top-right",
            autoClose: 4000,
        }
    );
};

const showBrowserNotification = (data, favicon) => {
    if (
        document.visibilityState !== "visible" &&
        Notification.permission === "granted"
    ) {
        const iconUrl = `${image_baseurl}/uploads/basicsetting/${favicon}`;
        new Notification(`📢 ${data.title || "Alert"}`, {
            body: data.message,
            icon:
                iconUrl ||
                "https://cdn-icons-png.flaticon.com/512/3602/3602123.png",
        });
    }
};
